import {
  getStatusTableColumn,
  getNameDescriptionTableColumn,
  getTimeTableColumn,
  getCopyWithContentTableColumn,
} from '@/utils/common/tableColumn'
import i18n from '@/locales'
import consts from '@scope/constants/consts'

export default {
  created () {
    this.columns = [
      getNameDescriptionTableColumn({
        field: 'name',
        title: i18n.t('scope.text_903'),
        edit: false,
        onManager: this.onManager,
        hideField: true,
        slotCallback: row => {
          return (
            <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{ row.name }</side-page-trigger>
          )
        },
      }),
      getStatusTableColumn({ field: 'certified_status', statusModule: 'tenant' }),
      getCopyWithContentTableColumn({
        field: 'creator_name',
        title: '实名',
        minWidth: 110,
      }),
      getCopyWithContentTableColumn({
        field: 'enterprise_name',
        title: '企业名称',
        minWidth: 110,
      }),
      getCopyWithContentTableColumn({
        field: 'mobile',
        title: '手机号',
        minWidth: 120,
      }),
      {
        field: 'customer_level',
        title: '用户等级',
        minWidth: 80,
        formatter: ({ cellValue }) => {
          if (cellValue in consts.customerLevelMap) return consts.customerLevelMap[cellValue]
          return '-'
        },
      },
      getCopyWithContentTableColumn({
        field: 'project_domain',
        title: i18n.t('scope.text_907'),
        minWidth: 150,
      }),
      {
        field: 'providers',
        title: i18n.t('scope.text_504'),
        width: 100,
        slots: {
          default: ({ row }, h) => {
            let ret = []
            if (row.providers && row.providers.length) {
              row.providers.map(item => {
                ret.push(<icon class='mr-2' type={ item.toLowerCase() } style="font-size: 20px" />)
              })
            } else {
              ret = '-'
            }
            return ret
          },
        },
      },
      getTimeTableColumn({ title: i18n.t('scope.text_498') }),
    ]
  },
}
